
export const goCashImage = 'https://gos3.ibcdn.com/goCashIcon-1661489696.png'
export const circularGif = "https://gos3.ibcdn.com/circularloader-1591795611.gif";
